module.exports = __webpack_public_path__ + "img/Orsun_Cercle.152441de.png";